"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _components = require("../../../components");

var _hooks = require("../../../hooks");

var _visuallyHidden = require("@react-aria/visually-hidden");

var _ModifierItemModule = _interopRequireDefault(require("./ModifierItem.module.scss"));

var _templateObject;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ModiifierItem = (0, _styledComponents["default"])(function (_ref) {
  var cellType = _ref.cellType,
      name = _ref.name,
      price = _ref.price,
      isNested = _ref.isNested,
      quantity = _ref.quantity,
      multiSelect = _ref.multiSelect,
      _ref$nestedItems = _ref.nestedItems,
      nestedItems = _ref$nestedItems === void 0 ? [] : _ref$nestedItems,
      onClick = _ref.onClick,
      className = _ref.className,
      increment = _ref.increment,
      decrement = _ref.decrement;

  var _useTemplate$useCell = _hooks.useTemplate.useCell(cellType),
      buttons = _useTemplate$useCell.buttons,
      labelTextStyles = _useTemplate$useCell.labelTextStyles,
      views = _useTemplate$useCell.views;

  return /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    Component: "li",
    className: "".concat(_ModifierItemModule["default"].modifierItem, " ").concat(className),
    dataTest: name
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !quantity
  }, /*#__PURE__*/_react["default"].createElement("div", {
    tabIndex: "-1",
    role: "button",
    className: _ModifierItemModule["default"]["modifierItem-overlay"],
    onClick: onClick,
    onKeyDown: onClick
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-name"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.primary
  }, name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-price"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: price
  }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
    type: labelTextStyles.secondary,
    className: _ModifierItemModule["default"]["modifierItem-price-value"]
  }, price)), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !isNested
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: multiSelect
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ModifierItemModule["default"]["modifierItem-selectors"]
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: quantity !== 0
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _ModifierItemModule["default"]["modifierItem-quantity-btn-minus"],
    onClick: decrement
  }), /*#__PURE__*/_react["default"].createElement(_components.Text, {
    "aria-live": "polite",
    type: labelTextStyles.tertiary
  }, /*#__PURE__*/_react["default"].createElement(_visuallyHidden.VisuallyHidden, null, name, " Quantity: "), quantity))), /*#__PURE__*/_react["default"].createElement(_components.ThemeButton, {
    type: buttons.primary,
    className: _ModifierItemModule["default"]["modifierItem-quantity-btn-plus"],
    onClick: increment
  }))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: !multiSelect
  }, /*#__PURE__*/_react["default"].createElement(_components.Condition.False, null, /*#__PURE__*/_react["default"].createElement(_components.Radio, {
    type: buttons.primary,
    className: _ModifierItemModule["default"].radio,
    value: quantity,
    onChange: onClick
  }))))), /*#__PURE__*/_react["default"].createElement(_components.Condition, {
    is: isNested && nestedItems.length
  }, /*#__PURE__*/_react["default"].createElement(_components.View, {
    type: views.background,
    Component: "ul",
    className: _ModifierItemModule["default"]["modifierItem-container--nestedItems"]
  }, nestedItems.map(function (item, index) {
    var _labelTextStyles$nest;

    return /*#__PURE__*/_react["default"].createElement(_components.View, {
      key: index,
      type: views.background,
      Component: "li",
      onClick: item === null || item === void 0 ? void 0 : item.onClick
    }, /*#__PURE__*/_react["default"].createElement(_components.Text, {
      type: (_labelTextStyles$nest = labelTextStyles === null || labelTextStyles === void 0 ? void 0 : labelTextStyles.nested) !== null && _labelTextStyles$nest !== void 0 ? _labelTextStyles$nest : labelTextStyles === null || labelTextStyles === void 0 ? void 0 : labelTextStyles.primary,
      className: _ModifierItemModule["default"].price
    }, item === null || item === void 0 ? void 0 : item.name));
  }))));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-bottom-color: ", "\n"])), function (props) {
  return props.theme.colors.alternateGray;
});

var _default = /*#__PURE__*/_react["default"].memo(ModiifierItem);

exports["default"] = _default;